import React, { useEffect, useState } from "react";
import { Table, Avatar, Pagination, Tabs, Modal, Tooltip, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import HeaderIcon from "./../../../assets/images/user/LeavePolicyIcon.svg";
import { setLeaveTableExpand } from "../../../redux/slices/userDasboardSlice";
import { useApplyLeave } from "../context/ApplyLeaveContext";
import { triggerNotification, useGetApiRequests } from "../../../common/CommonExport";
import PopupModal from "../../employee/employee-details/employee-profile/modal/PopupModal";
import { setLeaveReportPayload } from "../../../redux/slices/leaveReportPayloadSlice";
import { setLeaveReportTotal } from "../../../redux/slices/leaveListSlice";

import "./leaveList.scss";

const { TabPane } = Tabs;

const UserLeavePolicyTabs = () => {
  const dispatch = useDispatch();
  const expand = useSelector((state: any) => state?.userDashboard?.leaveTableExpand);
  const orgId = useSelector((state: any) => state?.organisationId?.id);

  const deleteLeaveRequest = useGetApiRequests("deleteLeaveRequest", "DELETE");
  const getLeaveReportsApi = useGetApiRequests("getLeaveReport", "GET");

  const { leaveList, init, currentPage, setCurrentPage, pageSize, setPageSize, count, getUsersList } = useApplyLeave();

  const [onLeaveTodayList, setOnLeaveTodayList] = useState<any[]>([]);
  const [onLeaveTodayLoader, setOnLeaveTodayLoader] = useState(false);
  const [myLeaveLoader, setMyLeaveLoader] = useState(false);
  const [onLeaveTodayCount, setOnLeaveTodayCount] = useState(0);
  const [onLeaveTodayPage, setOnLeaveTodayPage] = useState(1);
  const [onLeaveTodayPageSize, setOnLeaveTodayPageSize] = useState(10);


  const [currentDeleteId, setCurrentDeleteId] = useState<any>(null);
  const [deleteRequestModal, setDeleteRequestModal] = useState(false);
  const [popModal, setPopModal] = useState(false);
  const [modalerrMessage, setModalErrMessage] = useState("");
  const [modalResponse, setModalResponse] = useState("");
  const [modalButtonShow, setmodalButtonShow] = useState(true);

  const [isExpand, setIsExpand] = useState(true);
  const today = new Date().toISOString().split("T")[0];

  const getLeaveType = (fullName: string): string => {
    const words = fullName?.split(" ");
    if (words?.length >= 2) return `${words[0][0].toUpperCase()}${words[words.length - 1][0].toUpperCase()}`;
    if (words?.length === 1) return words[0][0].toUpperCase();
    return "";
  };

  const formatLeaveBalance = (hours: number): string => {
    const fullHours = Math.floor(hours);
    const minutes = Math.round((hours - fullHours) * 60);


    const adjustedHours = minutes === 60 ? fullHours + 1 : fullHours;
    const adjustedMinutes = minutes === 60 ? 0 : minutes;

    return `${adjustedHours}h ${adjustedMinutes}m`;
  };


  const isCurrentOrFutureMonth = (dateStr: string): boolean => {
    const [day, month, year] = dateStr.split("-").map(Number);
    const givenDate = new Date(year, month - 1, day);
    const now = new Date();
    const firstDayOfCurrentMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    return givenDate >= firstDayOfCurrentMonth;
  };

  const formatDateRange = (startDate: string, endDate: string): string => {
    const start = new Date(startDate?.split("-").reverse()?.join("-"));
    const end = new Date(endDate?.split("-").reverse()?.join("-"));
    return start.getTime() === end.getTime() ? endDate : `${startDate} to ${endDate}`;
  };

  const handelExpand = () => {
    setIsExpand((prev) => !prev);
    dispatch(setLeaveTableExpand(isExpand));
  };

  const handleCloseModal = () => setDeleteRequestModal(false);
  const handleClosePopUpModal = () => setPopModal(false);

  const handleApplyLeaveRequest = (record: any) => {
    setCurrentDeleteId(record);
    setDeleteRequestModal(true);
  };

  const deleteLeaveAPIRequest = async (id: string | number) => {
    try {
      setMyLeaveLoader(true);
      const response = await deleteLeaveRequest({}, {}, { id });
      if (response.status === 200) {
        init();
        setPopModal(true);
        setmodalButtonShow(false);
        if ("data" in response) {
          setModalErrMessage(response?.data?.message);
        } else {
          setModalErrMessage("Leave deleted successfully.");
        }
        setModalResponse("success");
        setTimeout(() => {
          handleClosePopUpModal();
          handleCloseModal();
          setMyLeaveLoader(false);
        }, 1500);
      }
    } catch (err: any) {
      triggerNotification("error", "", err?.message, "topRight");
    }
  };

  const handleDeleteLeaveRequest = () => {
    deleteLeaveAPIRequest(currentDeleteId?.employeeLeavePolicyRequestMapId);
  };

  const getLeaveReport = (page: number, size: number) => {
    setOnLeaveTodayLoader(true);
    const queryParams: any = {
      organisationId: orgId,
      start: (page - 1) * size,
      limit: size,
      leaveStatus: "approved",
      fromDate: today,
      toDate: today,
    };

    dispatch(setLeaveReportPayload(queryParams));

    getLeaveReportsApi("", queryParams)
      .then((response: any) => {
        const totalRecords = response?.data?.meta?.totalRecords || 0;
        setOnLeaveTodayCount(totalRecords);
        dispatch(setLeaveReportTotal(totalRecords));

        const formattedData = response?.data?.data.map((item: any, index: number) => ({
          policyType: item?.policyType,
          employeeName: item?.employeeName,
          fromDate: item?.fromDate,
          toDate: item?.toDate,
          duration: item?.duration,
          status: item?.status,
          reason: item?.reason,
          key: index + 1,
          formattedFromDate: item?.fromDate,
          formattedToDate: item?.toDate,
          lopCount: item?.lopCount,
        }));
        setOnLeaveTodayList(formattedData);
      })
      .catch((err: any) => {
        triggerNotification("error", "", err?.message, "topRight");
      })
      .finally(() => setOnLeaveTodayLoader(false));
  };

  const onDutyTypes = ["Client Visit", "WFH"];
  const leaveStatusList = leaveList?.filter((item: any) => !onDutyTypes.includes(item?.policyName));
  const onDutyLeaveList = leaveList?.filter((item: any) => onDutyTypes.includes(item?.policyName));

  const [activeTab, setActiveTab] = useState<string>("myLeaveStatus");

  useEffect(() => {
    if (activeTab === "myLeaveStatus") {
      setMyLeaveLoader(true);

      getUsersList()
        .finally(() => {
          setTimeout(() => {
            setMyLeaveLoader(false);
          }, 2000);
        });
    } else {
      getLeaveReport(onLeaveTodayPage, onLeaveTodayPageSize);
    }
  }, [activeTab, currentPage, pageSize, onLeaveTodayPage, onLeaveTodayPageSize]);

  const myLeaveColumns = [
    {
      title: "Types",
      dataIndex: "policyName",
      width: "20%",
      render: (text: string) => (
        <div className="flex items-center">
          <Avatar className={`leave-type-${text}`}>
            {getLeaveType(text)}
          </Avatar>
          <span className="ml-2">{text}</span>
        </div>
      ),
    },

    { title: "From", dataIndex: "startDate", width: "15%" },
    { title: "To", dataIndex: "endDate", width: "15%" },
    {
      title: "Duration",
      dataIndex: "duration",
      width: "15%",
      render: (text: any, record: any) => (
        <div className="flex">
          <p className="pl-3 flex items-center">
            {["Permission", "On duty"].includes(record?.policyName)
              ? formatLeaveBalance(text)
              : `${text}d`}

            {record?.lopCount > 0 && (
              <span className="pl-1 lop-count">
                (LOP-<span>{record.lopCount}</span>)
              </span>
            )}
          </p>
        </div>
      ),
    }

    ,
    {
      title: "Status",
      dataIndex: "status",
      width: "10%",
      render: (text: string) => (
        <div>
          {text === "approved" ? (
            <p className="leave_approved capitalize ">{text}</p>
          ) : text === "declined" ? (
            <p className="leave-rejected capitalize leave_notApproved">{text}</p>
          ) : (
            <p className="capitalize leave_pending">{text}</p>
          )}
        </div>
      ),
    },
    {
      title: "Reason",
      dataIndex: "reason",
      width: "20%",
      render: (text: string) => {
        if (!text) return null;

        const shouldEllipsis = text.length > 20;
        const displayText = shouldEllipsis ? text.slice(0, 20) + "..." : text;

        const content = (
          <span
            style={{
              display: "inline-block",
              maxWidth: "100%",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {displayText}
          </span>
        );

        return shouldEllipsis ? (
          <Tooltip title={text}>{content}</Tooltip>
        ) : (
          content
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      width: "5%",
      render: (_: any, record: any) => (
        <button
          disabled={record.status !== "pending" || !isCurrentOrFutureMonth(record?.endDate)}
          onClick={() => handleApplyLeaveRequest(record)}
          className="leaveDeleteButton material-symbols-outlined ml-3 cursor-pointer"
        >
          delete
        </button>
      ),
    },
  ];


  return (
    <div className={!expand ? "Leave__policy-table not-expand" : "expaned Leave__policy-table "}>
      <div className="employee-table z-[1] responsive mt-5">
        <div className="birth-anniversary__tab flex justify-between relative ">
          <div className="card-title justify-start flex">
            <img src={HeaderIcon} alt="" />
            <h4>Leave & On Duty status</h4>
          </div>
          <div className="flex justify-end relative top-[-9px]">
            <div className="expand expand-icon justify-end text-primary cursor-pointer">
              <span className="material-symbols-outlined text-lg" onClick={handelExpand}>
                open_in_full
              </span>
            </div>
          </div>
        </div>

        <Tabs activeKey={activeTab} onChange={setActiveTab} className="my-custom-tabs">
          <TabPane tab="Leave Status" key="myLeaveStatus">
            <Table columns={myLeaveColumns} loading={myLeaveLoader} dataSource={leaveStatusList} pagination={false} />
            <Pagination
              className="float-right flex flex-row p-6"
              showSizeChanger
              onShowSizeChange={(page, size) => {
                setPageSize(size);
                setCurrentPage(1);
              }}
              current={currentPage}
              total={count}
              pageSize={pageSize}
              onChange={(page) => setCurrentPage(page)}
            />
          </TabPane>

          <TabPane tab="On Duty Status" key="onLeaveToday">
            <Table columns={myLeaveColumns} dataSource={onDutyLeaveList} pagination={false} loading={myLeaveLoader} />
            <Pagination
              className="float-right flex flex-row p-6"
              showSizeChanger
              onShowSizeChange={(page, size) => {
                setOnLeaveTodayPageSize(size);
                setOnLeaveTodayPage(1);
              }}
              current={onLeaveTodayPage}
              total={onLeaveTodayCount}
              pageSize={onLeaveTodayPageSize}
              onChange={(page) => setOnLeaveTodayPage(page)}
            />
          </TabPane>
        </Tabs>
      </div>

      <Modal title={`Delete ${currentDeleteId?.policyName}`} centered open={deleteRequestModal} onCancel={handleCloseModal} footer={null} maskClosable={false}>
        <p className="my-4 font-rubik">
          Are you sure you want to delete this <span className="text-[#d34a7c]">{currentDeleteId?.policyName}</span> on{" "}
          <span className="text-[#d34a7c]">{formatDateRange(currentDeleteId?.startDate, currentDeleteId?.endDate)}</span> ?
        </p>
        <div className="flex justify-end">
          <button className="addButton secondary mr-4" onClick={handleCloseModal}>
            Cancel
          </button>
          <Button loading={myLeaveLoader} className="addButton" onClick={handleDeleteLeaveRequest}>
            Delete
          </Button>
        </div>
      </Modal>

      {popModal && <PopupModal message={modalerrMessage} open={popModal} handleModalClose={handleClosePopUpModal} response={modalResponse} modalButtonShow={modalButtonShow} />}
    </div>
  );
};

export default UserLeavePolicyTabs;
